export var HypotheticalsSortColumn;
(function (HypotheticalsSortColumn) {
    HypotheticalsSortColumn["NAME"] = "name";
    HypotheticalsSortColumn["OWNER"] = "owner";
    HypotheticalsSortColumn["USER_MODIFY_DATE"] = "modify_date";
})(HypotheticalsSortColumn || (HypotheticalsSortColumn = {}));
export var HypotheticalsDropdownOption;
(function (HypotheticalsDropdownOption) {
    HypotheticalsDropdownOption["SHARE"] = "share";
    HypotheticalsDropdownOption["RENAME"] = "rename";
    HypotheticalsDropdownOption["MOVE"] = "move";
    HypotheticalsDropdownOption["DELETE"] = "delete";
})(HypotheticalsDropdownOption || (HypotheticalsDropdownOption = {}));
